"use client"

import { useEffect } from "react"

/**
 * Helper function which applies themes to the HTML element, so
 * it applies to everything underneath (eg even modals on publications).
 */
export default function ThemeApplier({
  children,
  theme,
}: {
  children?: React.ReactNode
  theme: string
}) {
  useEffect(() => {
    // Split the theme string into individual classes
    const themeClasses = theme.split(" ")

    // Apply all theme classes to the HTML element
    themeClasses.forEach((className) => {
      document.documentElement.classList.add(className)
    })

    // Clean up when component unmounts or theme changes
    return () => {
      themeClasses.forEach((className) => {
        document.documentElement.classList.remove(className)
      })
    }
  }, [theme])

  const classes = theme.split(" ")

  // Also apply it to this element, so that it's available in the initial
  // React server render.
  return <div className={classes.join(" ")}>{children}</div>
}
